import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-column-settings` component represents a settings window for a column.
 * @deprecated Use `ch-tabular-grid` component instead. Use `ch-tabular-grid-column-settings` instead.
 */
export class ChGridColumnSettings {
    constructor() {
        this.column = undefined;
        this.show = false;
    }
    windowClosedHandler(eventInfo) {
        eventInfo.stopPropagation();
        this.column.showSettings = false;
    }
    columnSettingsChangedHandler() {
        this.column.showSettings = false;
    }
    render() {
        return (h(Host, { key: 'b9b4012c9dbf861b64b79cb5aa7a7812e0b5e11f' }, h("ch-window", { key: '4118cc7c16209b8a55bc23ca217f0a2126b98e94', modal: true, container: this.column, xAlign: "inside-start", yAlign: "outside-end", caption: this.column.columnName, closeText: "Close", closeOnOutsideClick: true, closeOnEscape: true, allowDrag: "header", hidden: !this.show, exportparts: "mask,window,header,caption,close,main,footer" }, h("slot", { key: '8e02e36dff60c7a97e7b1d5a5ce722ef8e4fc012' }))));
    }
    static get is() { return "ch-grid-column-settings"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-column-settings.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-column-settings.css"]
        };
    }
    static get properties() {
        return {
            "column": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChGridColumnElement",
                    "resolved": "HTMLChGridColumnElement",
                    "references": {
                        "HTMLChGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The `HTMLChGridColumnElement` that the settings window is associated with."
                }
            },
            "show": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the settings window is currently shown or not."
                },
                "attribute": "show",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get listeners() {
        return [{
                "name": "windowClosed",
                "method": "windowClosedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "columnSettingsChanged",
                "method": "columnSettingsChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
